import { Block, Inline, Text, helpers } from '@contentful/rich-text-types'
import React from 'react'
import styles from './rich-text.module.scss'
import { getShortcodeName, isShortcode } from './shortcode'
import { isTableHeaderShortcodeName } from './shortcode/types'

interface TableProps extends Block {
  children?: React.ReactNode
}

export const Table: React.FC<TableProps> = (props) => {
  return (
    <table className={styles.table}>
      <tbody>{props.children}</tbody>
    </table>
  )
}

interface TableCellProps extends Block {
  children?: React.ReactNode
}

export const TableCell: React.FC<TableCellProps> = (props) => {
  const isTableHeader = doesNodeContainShortcodeForIsTableHeader(props)
  return isTableHeader ? (
    <th className={styles.tableCell}>{props.children}</th>
  ) : (
    <td className={styles.tableCell}>{props.children}</td>
  )
}

const doesNodeContainShortcodeForIsTableHeader = (node: Block | Inline | Text) => {
  if (helpers.isInline(node)) {
    if (isShortcode(node)) {
      if (isTableHeaderShortcodeName(getShortcodeName(node))) {
        return true
      }
    }
    return false
  }

  if (helpers.isBlock(node)) {
    for (let i = 0; i < node.content.length; ++i) {
      if (doesNodeContainShortcodeForIsTableHeader(node.content[i])) {
        return true
      }
    }
  }
  return false
}
